import { makeRequest, buildOptions } from './ServiceHelpers';
export const getRuleSet = (referenceId, accessToken) => {
  const options = buildOptions();

  return makeRequest(
    `https://rule.products.cimpress.io/v1/ruleSets/`,
    `?referenceId=${referenceId}`,
    options,
    'getting ruleset for the given sku'
  );
};
